import { Box, styled } from '@mui/material';

const GutterHandleBox = styled(
  Box,
  { shouldForwardProp: prop => !['isDragging','orientation'].includes(prop) }
)(({ theme, isDragging, orientation }) => ({
    // horizontal split → vertical bar
    width: orientation === 'horizontal'
      ? theme.spacing(0.75) 
      : theme.spacing(3),      // wider for vertical split
    height: orientation === 'horizontal'
      ? theme.spacing(3)       // taller for horizontal split
      : theme.spacing(0.75),
    // center it in the gutter
    margin: orientation === 'horizontal'
      ? '0 auto'
      : 'auto 0',

    backgroundColor: theme.palette.grey[400],
    borderRadius: theme.shape.borderRadius,
    opacity: isDragging ? 1 : 0,
    cursor: isDragging
      ? orientation === 'horizontal'
        ? 'col-resize'
        : 'row-resize'
      : 'auto',
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.short,
    }),

    // show on hover
    '.gutter:hover &': {
      opacity: 1,
      cursor: orientation === 'horizontal'
        ? 'col-resize'
        : 'row-resize',
    },
}));

export const GutterHandle = ({ isDragging = false, orientation = 'horizontal' }) => (
  <GutterHandleBox
    isDragging={isDragging}
    orientation={orientation}
  />
);
